import React from 'react';

// Helper to convert touch events to mouse events for compatibility
export function wrapTouchEvent(
  handler: (e: React.MouseEvent) => void
): (e: React.TouchEvent) => void {
  return (e: React.TouchEvent) => {
    if (e.touches.length !== 1) return; // Only handle single touch
    
    const touch = e.touches[0];
    
    // Create a synthetic mouse event
    const mouseEvent = {
      ...e,
      clientX: touch.clientX,
      clientY: touch.clientY,
      pageX: touch.pageX,
      pageY: touch.pageY,
      screenX: touch.screenX,
      screenY: touch.screenY,
      button: 0,
      buttons: 1,
      preventDefault: () => e.preventDefault(),
      stopPropagation: () => e.stopPropagation(),
      target: e.target,
      currentTarget: e.currentTarget,
    } as unknown as React.MouseEvent;
    
    handler(mouseEvent);
  };
}

// Helper to handle both mouse and touch events
export function handlePointerStart(
  e: React.MouseEvent | React.TouchEvent,
  handler: (e: React.MouseEvent) => void
) {
  if ('touches' in e) {
    wrapTouchEvent(handler)(e);
  } else {
    handler(e);
  }
}